module.exports = __webpack_public_path__ + "img/pd_b1_img3.33390a21.png";